import {Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {SelectedItem} from '../../../order/models/order';
import {FormGroup, Validators} from '@angular/forms';
import {GroupConfig} from '../../models/config';
import {L10N_LOCALE, L10nLocale, L10nTranslationService} from 'angular-l10n';
import {combineLatest, Observable, Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import * as fromShared from '../../reducers';
import {EMPTY_GUID, SendBackResultCode} from '../../index';
import * as _ from 'lodash';
import * as fromRoot from '../../reducers';
import {MergeSubscriptionAction, MergeSubscriptionNewSiteAction} from '../../../site/actions/merge-subscription-of-site';
import {ReturnPlayerUpdateStatusAction} from '../../actions/anomaly-player-return';
import {GetFormsServiceLocal} from '../../../site/services/get-form-service';
import {GetConfigSiteService} from '../../../site/services/get-config-site.service';
import {ModalComponent} from '@storever/modal-confirmation';
import {MergeSiteAction} from '../../../site/actions/merge-site-of-client';
import {DuplicateService} from '../../services/duplicate.service';
import {Router} from '@angular/router';
import {debounceTime} from 'rxjs/operators';
import {LoadMySitesAction} from '../../actions/my-sites';
import {ClearALLSubListAction} from '../../actions/subscription-list';
import {HeaderTitleClearAction} from '../../actions/header-title';

@Component({
  selector: 'storever-merge-site-dialog',
  templateUrl: './merge-site-dialog.component.html',
  styleUrls: ['./merge-site-dialog.component.css']
})
export class MergeSiteDialogComponent implements OnInit, OnDestroy {

  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedSub: any [] = [];
  private sub$: Subscription;
  private subscriptions = [];
  form: FormGroup;
  formConfig: GroupConfig;
  newForm: FormGroup;
  newFormConfig: GroupConfig;
  // tslint:disable-next-line:no-any
  error: any;
  // tslint:disable-next-line:no-any
  isExist = false;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  newSiteNameLoc: any;
  subscriptionsUuidList: string[];
  subscriptionsList: object[];
  @ViewChild('elementGroup', {static: true}) el: ElementRef;

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private getFormsService: GetFormsServiceLocal,
              private translation: L10nTranslationService,
              private bsModalRef: BsModalRef,
              private router: Router,
              private modalService: BsModalService,
              private duplicateService: DuplicateService,
              private store: Store<fromShared.AppState>,
              private getConfig: GetConfigSiteService) { }

  ngOnInit(): void {
    this.getSelectItemsInfo();
    this.error = 'false';
    this.form = this.getFormsService.getMergeSubscriptionOfSite();
    this.newForm = this.getFormsService.getMergeSubscriptionOfNewSite();
    this.formConfig = this.getConfig.getMergeSubscriptionOfClient();
    this.newFormConfig = this.getConfig.getMergeSubscriptionOfClientNewSite();
    this.store.dispatch(new LoadMySitesAction(this.router.url.split('?')[0].split('/')[1]));
    this.sub$ = this.form.valueChanges.subscribe(data => {
      if (data && data.siteName) {

        this.newForm.get(['NewSiteName']).setValidators([]);
        this.newForm.get(['NewSiteName']).updateValueAndValidity();
      } else {
        this.newForm.get(['NewSiteName']).setValidators([Validators.required]);
        this.newForm.get(['NewSiteName']).updateValueAndValidity();
      }
    })
    this.subscriptions.push(this.sub$);
    this.sub$ = this.newForm.valueChanges.pipe(debounceTime(700)).subscribe(data => {

      if (data && data.NewSiteName && (this.newSiteNameLoc !== data.NewSiteName)) {
        this.newSiteNameLoc = data.NewSiteName;
        this.form.get(['siteName']).setValidators([]);
        this.form.get(['siteUuid']).setValidators([]);
        this.form.get(['siteUuid']).updateValueAndValidity();
        this.form.get(['siteName']).updateValueAndValidity();
        this.sub$ = this.duplicateService.siteName(
          this.router.url.split('?')[0].split('/')[1],
          data.NewSiteName.replace(/^\s+|\s+$/g, ''),
          EMPTY_GUID).subscribe(c => {
          // @ts-ignore
          if (c && c.data && c.data.value) {
            this.error = 'A site with this name already exists. Please choose a different name.';
            this.isExist = false;
          } else {
            this.error = 'false';
            this.isExist = true;
          }

        })
      }
      if (!data.NewSiteName) {
        this.form.get(['siteName']).setValidators([Validators.required]);
        this.form.get(['siteUuid']).setValidators([Validators.required]);
        this.form.get(['siteUuid']).updateValueAndValidity();
        this.form.get(['siteName']).updateValueAndValidity();
      }

    })

    this.subscriptions.push(this.sub$);


  }
  sendNew(): void {
    this.close();
    if (this.newForm.get('NewSiteName').value) {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'You will move {{countSubscription}} subscription(s) to the site {{siteName}}.',
        variable: null,
        deleteBtn: false,
        hideBtnOk: true
      };
      this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
      this.bsModalRef.content.message = this.translation.translate('SUBSCRIPTION_LIST_MERGE_SITE_MESSAGE',
        {countSubscription: this.subscriptionsList.length, siteName: this.newForm.get('NewSiteName').value});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
          this.store.dispatch(new MergeSubscriptionNewSiteAction({
            'siteUuidDestination': this.newForm.get('NewSiteUuid').value,
            'NewSiteNameDestination': this.newForm.get('NewSiteName').value,
            'NewSiteExternalIDDestination': this.newForm.get('NewSiteExternalID').value,
            'subscriptionsUuid': this.subscriptionsList
          }));
          this.form.reset();
          if (this.subscriptions.length) {
            this.subscriptions.forEach(sub => sub.unsubscribe());
          }
          this.close();
        }

      });
      this.subscriptions.push(this.sub$);
    }

  }

  send(): void {
    this.close();
    if (this.form.get('siteName').value) {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'You will move {{countSubscription}} subscription(s) to the site {{siteName}}.',
        variable: null,
        deleteBtn: false,
        hideBtnOk: true
      };
      // @ts-ignore
      this.bsModalRef = this.modalService.show(ModalComponent, {initialState});
      this.bsModalRef.content.message = this.translation.translate('SUBSCRIPTION_LIST_MERGE_SITE_MESSAGE',
        {countSubscription: this.subscriptionsList.length, siteName: this.form.get('siteName').value});
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
          this.store.dispatch(new MergeSubscriptionAction({
            'siteUuidDestination': this.form.get('siteUuid').value,
            'siteNameDestination': this.form.get('siteName').value,
            'subscriptionsUuid': this.subscriptionsList }));
          this.form.reset();
          if (this.subscriptions.length) {
            this.subscriptions.forEach(sub => sub.unsubscribe());
          }
          this.close();
        }

      });
      this.subscriptions.push(this.sub$);

    }

  }

  close(): void {
   // this.error = 'false';
   // this.form.reset();
    this.bsModalRef.hide();
  }
  cancel(): void {
  if (this.subscriptions.length) {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  this.bsModalRef.hide();
  }
  open(): void {
    // console.log('open')
    this.staticModal.show();
  }

  getSelectItemsInfo(): void {
    this.subscriptionsUuidList = [];
    this.subscriptionsList = [];
    this.selectedItem$ = this.store.pipe(select(fromShared.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
          this.selectedSub.push({name: this.selectedItem[j].name , uuid: this.selectedItem[j].uuid  , clientUuid: this.selectedItem[j].clientUuid  });
          this.subscriptionsUuidList.push(this.selectedItem[j].uuid);
          this.subscriptionsList.push({ name : this.selectedItem[j].name , uuid: this.selectedItem[j].uuid});
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromShared.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedSub.push({name: data.name , uuid: data.uuid  , clientUuid: data.clientUuid});
        this.subscriptionsUuidList.push(data.uuid);
        this.subscriptionsList.push({ name : data.name , uuid: data.uuid});
      }

    });
    this.subscriptions.push(this.sub$);
  }

  removeSubscription(index: number): void {
    if (this.selectedItem.length > 1) {
      let selectedItemTemp;
      selectedItemTemp = _.cloneDeep(this.selectedItem);
      if (index > -1) {
        selectedItemTemp.splice(index, 1);
      }
      this.selectedItem = selectedItemTemp;
      this.selectedSub = selectedItemTemp;
    }
  }

  ngOnDestroy(): void {

  }
}
